/* eslint-disable consistent-return */
/**
 * other参数: {responseType: 'blob'} 可设置此类属性等等等...
 *
 * 相关api，请求方式如下
 * POSTFROM(url, params, other)，   application/x-www-form-urlencoded格式
 * POSTJSON(url, params, other)，   application/json格式
 * GET(url, params, other)，        GET请求方式
 * POSTJSONALL(url, params, other)  自定义模式，方便自定义header的格式
 */
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import API from '@szyx/axios'
import {
  ApiRequest,
  SuccessBase,
  ErrBase,
  SuccessNotify,
  ErrNotify,
} from '@/components/base-modal/index'
import { envTypeData } from '@/utils/public'
import agent from './agent'
import openService from './openService'
import welcome from './welcome'

Vue.use(VueCookies)

const envType = VueCookies.get('envType')
const userLoginInfo = VueCookies.get('userLoginInfo')
const envApi = VueCookies.get('envApi')
console.log('API初始化22222,最终的envApi', envApi)

API.interceptors.request.use((request) => {
  const requestData = request
  // requestData.headers.Cookie = VueCookies.get('SESSION');
  return requestData
})
API.interceptors.response.use(
  (response) => {
    // 登录已经超时,超过30分钟
    if (response.status === '001x043') {
      VueCookies.remove('userLoginInfo')
      VueCookies.remove('envType')
      VueCookies.remove('envApi')
      VueCookies.remove('currentClientId')
      VueCookies.remove('username')
      VueCookies.remove('defaultEnvOfTwo')
      window.location.href = '../homeList/homePage.html'
    }
    console.log("response====",response.type)
    // 判断是否是下载类文件
    if (response instanceof Blob) {
      if (["application/json", "application/x-www-form-urlencoded"].includes(response.type)) {
        throw new Error(JSON.stringify({
          status: "012x011",
          message: "操作失败"
        }));
      } else {
        return response
      }
    }
    console.log("response.status",response.status)
    if (response.status === '0' || response.status === undefined) {
      return response
    }
    // 否则都是错了
    throw new Error(JSON.stringify(response))
    // if (response.status !== '0') {
    //   ErrBase(`${response.message}，错误码：${response.status}`);
    // }
  },
  (error) => {
    throw error
  }
)

// 错误处理
const errorHandle = (error) => {
  // 处理错误,尝试获取error的message展示
  try {
    const tmp = JSON.parse(error.message)
    const { message, status } = tmp
    ErrBase(`${message}，错误码：${status}`)
  } catch (e) {
    ErrBase(error.toString())
  }
}
API.setErrorHandle(errorHandle)
export default {
  ApiRequest,
  SuccessBase,
  ErrBase,
  SuccessNotify,
  ErrNotify,
  // --start---- 冠心
  gxGetUserInfo: (params) =>
    API.GET('/openapi/doctorManage/getUserInfo', params),
  // 生成订单接口
  gxSaveOrder: (params) =>
    API.POSTJSON('/openapi/doctorManage/saveOrder', params),
  // 获取支付二维码接口   /testopenapi
  gxPay: (params) => API.POSTJSON('/openapi/doctorManage/pay', params),
  // 支付结果查询
  gxGetPayResult: (params) =>
    API.GET('/openapi/packageOrder/getPayResult', params),
  // 获取发票信息
  getTaxNobyName: (params) =>
    API.POSTJSON('/openapi/doctorManage/getTaxCodeByName', params),
  // 获取税号
  getTaxNoByCode: (params) =>
    API.POSTJSON('/openapi/doctorManage/getTaxNoByCode', params),
  // 发票冲红
  getRedTax: (params) => API.POSTJSON('/openapi/doctorManage/redTax', params),
  // --end---

  // 账户概览--证书量
  getCertNum: (params) => API.GET(`/${envApi}/stastic/getCertNum`, params),
  // 通知服务（判断是否存在）
  checkFirmService: (params) =>
    API.POSTJSON(`/${envApi}/subService/checkFirmService`, params),

  // 账户概览--订阅服务
  getServiceNum: (params) =>
    API.GET(`/${envApi}/stastic/getServiceNum`, params),
  // 初审用户--列表
  getTempDoctorList: (params) =>
    API.POSTJSON(`/${envApi}/cert/getTempDoctorList`, params),
  // 是否开启用户复审服务
  getIsOpenRecheckServiceApi: (params) => API.POSTJSON(`/${envApi}/package/check`, params),
  // 获取复审操作手机号验证码
  getRecheckVerifyCodeApi: (params) => API.POSTJSON(`/${envApi}/rejectAudit/sendSms`,params),
  // 复审操作
  recheckPassApi: (params) => API.POSTJSON(`/${envApi}/rejectAudit/pass`,params),
  // 初审用户--数据删除
  removeTempDoc: (params) => API.GET(`/${envApi}/cert/removeTempDoc`, params),
  //  可信用户--列表
  getDoctorList: (params) =>
    API.POSTJSON(`/${envApi}/cert/getDoctorList`, params),
  // 可信用户--详情
  getCertInfo: (params) => API.POSTJSON(`/${envApi}/cert/getCertInfo`, params),
  // 可信用户--手机启用/停用
  updateDocStatus: (params) =>
    API.POSTJSON(`/${envApi}/cert/updateDocStatus`, params),
  // 可信用户--更换手机--获取验证码
  getDoctorMssgId: (params) =>
    API.POSTJSON(`/${envApi}/cert/getDoctorMssgId`, params),
  // 可信用户--确定修改手机号
  doctorChangePhone: (params) =>
    API.POSTJSON(`/${envApi}/cert/doctorChangePhone`, params),
  // 患者账号
  accountAdd: (params) =>
    API.POSTJSON(`/${envApi}/patient/account/add`, params),
  accountUpdate: (params) =>
    API.POSTJSON(`/${envApi}/patient/account/update`, params),
  accountDel: (params) =>
    API.POSTJSON(`/${envApi}/patient/account/del`, params),
  accountList: (params) =>
    API.POSTJSON(`/${envApi}/patient/account/list`, params),
  // 患者签名
  patientList: (params) =>
    API.POSTJSON(`/${envApi}/patient/sign/getListByPage`, params),
  // 患者签名详情
  patientDetail: (params) =>
    API.GET(`/${envApi}/patient/sign/getSignDetail`, params),
  // 患者账号，批量导入检测
  accountImportExcel: (params) =>
    API.POSTJSON(`/${envApi}/patient/account/importExcel`, params),
  // 患者批量导入库
  accountExcelToDB: (params) =>
    API.POSTFROM(`/${envApi}/patient/account/excelToDB`, params),
  // 公告 --列表
  noticeList: (params) => API.POSTJSON(`/${envApi}/notice/list`, params),
  // 系统预警--列表
  getMonitorPage: (params) =>
    API.POSTJSON(`/${envApi}/monitor/getMonitorPage`, params),
  // 签章管理--列表
  getUserList: (params) =>
    API.POSTJSON(`/${envApi}/cert/stamp/getUserList`, params),
  // 签章审核
  listAudit: (params) =>
    API.POSTJSON(`/${envApi}/cert/stamp/listAudit`, params),
  // 签章上传
  signUpLoad: (params) => API.POSTJSON(`/${envApi}/cert/stamp/upLoad`, params),
  // 签名流水查询列表
  searchServiceDetail: (params) =>
    API.POSTJSON(`/${envApi}/doctorSign/list`, params),
  // 医院签章流水
  searchHospitalSign: (params) => API.POSTJSON(`/${envApi}/order/firmPdfSign/list`, params),
  // 医院签章流水-科室
  queryHospitalSignDepartment: (params) => API.GET(`/${envApi}/order/firmPdfSign/getDepartList`, params),
  // 签名流水--归档范围（已弃用）
  // getarchivelist: (params) => API.GET(`/${envApi}/stastic/getarchivelist`, params)
  // 已订阅服务列表数据
  querySubService: (params) =>
    API.POSTJSON(`/${envApi}/packageOrder/querySubService`, params),
  // 服务包管理--服务包分布数据
  computeServicePack: (params) =>
    API.POSTJSON(`/${envApi}/packageOrder/computeServicePack`, params),
  // 服务包管理--服务包管理数据
  statisticalTotalAmount: (params) =>
    API.POSTJSON(`/${envApi}/packageOrder/statisticalTotalAmount`, params),
  // 服务包管理--服务包详情数据
  getServicePackList: (params) =>
    API.POSTJSON(`/${envApi}/packageOrder/getServicePackList`, params),
  // 服务包管理--已付款--使用
  useOrder: (params) =>
    API.POSTJSON(`/${envApi}/packageOrder/useOrder`, params),
  // 服务包购买详情
  getOrderDetail: (params) =>
    API.GET(`/${envApi}/packageOrder/getOrderDetail`, params),
  // 服务包--支付
  pay: (params) => API.POSTJSON(`/${envApi}/packageOrder/pay`, params),
  // 发票详情
  invoiceGet: (params) => API.GET(`/${envApi}/invoice/get`, params),
  // 确定补开发票--去支付
  invoiceUpdate: (params) => API.POSTJSON(`/${envApi}/invoice/update`, params),
  // 待付款--关闭
  closeOrder: (params) =>
    API.POSTJSON(`/${envApi}/packageOrder/closeOrder`, params),
  // 服务包id
  getTemplate: (params) =>
    API.GET(`/${envApi}/packageOrder/getTemplate`, params),
  // 获取服务列表
  getDiscount: (params) =>
    API.GET(`/${envApi}/packageOrder/getDiscount`, params),
  // 购买服务包--支付
  placeOrder: (params) =>
    API.POSTJSON(`/${envApi}/packageOrder/placeOrder`, params),
  // 初审用户--新增
  addTempUser: (params) => API.POSTJSON(`/${envApi}/cert/addTempUser`, params),
  // 我的账户信息
  getAuthInfo: (params) => API.GET(`/${envApi}/user/getAuthInfo`, params, {
    needToken: true
  }),
  // 修改密码
  updateCredenceAppend: (params) =>
    API.POSTJSON(`/openapi/user/updateCredenceAppend`, params),
  // 授权记录管理
  grantListByPage: (params) =>
    API.POSTJSON(`/${envApi}/grant/listByPage`, params),
  // grantListByPage: (params) => API.POSTJSON('http://yapi.51trust.com/mock/236/openapi/grant/listByPage', params),
  // 授权签名分页查询(详情)
  grantGetSignList: (params) =>
    API.POSTJSON(`/${envApi}/grant/getSignList`, params),
  // 获取厂商
  getAllFirmList: (params) => API.POSTJSON(`/${envApi}/tms-admin/api/firm/list`, { pageNum: 1, pageSize: 1000 }),
  // grantGeSignList: (params) => API.POSTJSON('http://yapi.51trust.com/mock/236/openapi/grant/geSignList', params),

  /** *************** 3代理商和4代理商销api (没有环境区分)************************************ */
  // 初审厂商审理搜索
  // searchVendorAudit: (params) => API.POSTJSON('/openapi/firm/tempList', params),
  // 初审厂商添加，编辑
  // addVendorAudit: (params) => API.POSTJSON('/openapi/firm/editTemp', params),
  // 初审厂商删除
  // delVendorAudit: (params) => {
  //   const url = `/openapi/firm/delTemp?uniqueid=${params.uniqueid}`
  //   return API.POSTJSON(url, params)
  // },
  // 获取代理商信息
  // getSale: () => API.GET('/openapi/agent/sale/sel'),
  //  获取可信厂商列表
  // getVendorAuditBeleveList: (params) =>
  //   API.POSTJSON('/openapi/firm/list', params),
  // 可信厂商-修改
  // changeModify: (params) => API.POSTJSON('/openapi/firm/modify', params),
  // 厂商服务预警-获取列表
  // getWarnLisy: (params) =>
  // API.POSTJSON('/openapi/subService/packageWarnList', params),
  // 厂商费用统计-统计列表
  // getMoneyList: (params) =>
  // API.POSTJSON('/openapi/subService/serviceFeeList', params),
  // 厂商费用统计-详情
  // firmPackageUseInfo: (params) =>
  //   API.POSTJSON('/openapi/subService/firmPackageUseInfo', params),

  // 代理商-警告列表
  // getWarnList: (params) =>
  //   API.POSTJSON('/openapi/subService/packageWarnList', params),
  /** ********************** end ********************************** */
  // 服务包购买订单确认--检测是否已经支付
  getPayResult: (params) =>
    API.GET(`/${envApi}/packageOrder/getPayResult`, params),
  // 登录账号绑定厂商
  // bindClientId: (params) => {
  //   return API.POSTJSON('/openapi/user/bindClientId', params)
  // },

  // 账号id绑定到厂商信息1 -绑定生成环境
  bindAccountToFirm: (params) =>
    API.POSTJSON('/openapi/firm/bindAccountToFirm', params),
  // 绑定集成环境
  bindAccountToFirm_test: (params) =>
    API.POSTJSON('/testopenapi/firm/bindAccountToFirm', params),
  // 厂商ID绑定到账号信息2
  bindFirmToAccount: (params) =>
    API.POSTJSON('/openapi/user/bindFirmToAccount', params),
  // 修改登录账号
  updateEmail: (params) => API.POSTJSON(`/openapi/user/updateEmail`, params),
  // 邮箱注册获取验证码
  toEmailCodeRegist: (params) =>
    API.POSTJSON(`/openapi/user/toEmailCodeRegist`, params),
  // 手机注册获取验证码
  getAboutPhoneCodeApi: (params) => API.GET(`/openapi/user/sendRegistVerifyCode`, params),
  // 登陆后修改手机号
  modifyPhoneAtLoginApi: (params) => API.POSTJSON(`/openapi/user/updatePhone`, params),
  // 同步登录接口（跨环境快捷登录）线上环境切换集成环境
  // synLogin: (params) => {
  //   return API.POSTJSON(`/testopenapi/user/synLogin`, params)
  // },
  synLogin_test: (params) => API.POSTJSON('/testopenapi/user/synLogin', params),
  // 登录账号创建厂商（厂商上线）
  // saveTemp: (params) => {/testtestopenapi/user/synLogin
  //   return API.POSTJSON('openapi/firm/saveTemp', params)
  // },/testtestopenapi/user/synLogin
  saveTempForFirm: (params) =>
    API.POSTJSON(`/${envApi}/firm/saveTempForFirm`, params),
  // 添加初审厂商（厂商自注册）--集成环境
  saveTempForFirm_test: (params) =>
    API.POSTJSON('/testopenapi/firm/saveTempForFirm', params),
  // 添加初审厂商--线上环境
  saveTempForFirm_master: (params) =>
    API.POSTJSON('/openapi/firm/saveTempForFirm', params),
  editTempForFirm: (params) =>
    API.POSTJSON(`/${envApi}/firm/editTempForFirm`, params),
  // 可信厂商-修改
  editWaitingAudit: (params) => API.POSTJSON(`/${envApi}/firm/modify`, params),
  // 账户概览--通知服务--获取厂商回调地址列表
  getCallBackList: (params) =>
    API.GET(`/${envApi}/subService/getCallBackList`, params),
  // 账户概览--通知服务--保存厂商回调地址列表
  updateFirmNotifyUrl: (params) =>
    API.POSTJSON(`/${envApi}/subService/updateFirmNotifyUrl`, params),
  // 账户概览--通知服务 --连接测试按钮
  linkNotifyUrl: (params) =>
    API.POSTFROM(`/${envApi}/subService/linkNotifyUrl`, params),
  // 检查集成状态
  checkIntegration: (params) =>
    API.GET(`/${envApi}/firm/checkIntegration`, params),
  // 用户excel导入接口  检查数据
  importExcel: (params) =>
    API.POSTJSON(`/${envApi}/cert/temp/importExcel`, params),
  // 下载模版
  exportModel: (params) => API.GET(`/${envApi}/cert/temp/exportModel`, params),
  // 导出合格数据
  exportExcel: (params) => API.GET(`/${envApi}/cert/temp/exportExcel`, params),
  // 检查数据后--导入合格数据
  ExcelToDB: (params) => API.POSTFROM(`/${envApi}/cert/temp/ExcelToDB`, params),
  // 自主挂靠-初审用户列表（分页）
  userBindList: (params) =>
    API.POSTJSON(`/${envApi}/cert/userBind/listByPage`, params),
  // 自主挂靠-初审用户详情
  userBindDetail: (params) =>
    API.GET(`/${envApi}/cert/userBind/detail`, params),
  // 自主挂靠-审核 --批量
  userBindAudit: (params) =>
    API.POSTJSON(`/${envApi}/cert/userBind/audit`, params),
  // 审核拒绝 /openapi/cert/userBind/refuse
  userBindRefuse: (params) =>
    API.POSTJSON(`/${envApi}/cert/userBind/refuse`, params),
  // 待审用户修改接口
  tempDoctorListUpdate: (params) =>
    API.POSTJSON(`/${envApi}/cert/tempDoctor/update`, params),
  // 可信用户修改
  trustUserUpdate: (params) =>
    API.POSTJSON(`/${envApi}/cert/trust/update`, params),
  // 科室列表
  departmentList: (params) =>
    API.POSTJSON(`/${envApi}/department/pageList`, params),
  // 新增科室
  addDepartment: (params) => API.POSTJSON(`/${envApi}/department/add`, params),
  // 删除科室
  delDepartment: (params) => API.POSTJSON(`/${envApi}/department/del`, params),

  // 部门签章
  queryDepartmentSignature: (params) => API.POSTJSON(`/${envApi}/departStamp/listByPage`, params),
  // 新增
  createDepartmentSignature: (params) => API.POSTJSON(`/${envApi}/departStamp/add`, params),
  // 编辑部门签章
  saveDepartmentSignature: (params) => API.POSTJSON(`/${envApi}/departStamp/modifyPerson`, params),
  // 删除部门签章
  delDepartmentSignature: (params) => API.GET(`/${envApi}/departStamp/del`, params),

  // 签名订单详情
  doctorSignDetail: (params) => API.GET(`/${envApi}/doctorSign/detail`, params),
  //  修改同步用户
  updateSynDoctor: (params) =>
    API.POSTJSON(`/${envApi}/cert/synDoctor/update`, params),
  // 待审用户信息
  tempDoctorDetail: (params) =>
    API.GET(`/${envApi}/cert/tempDoctor/info`, params),
  ...agent,
  ...openService,
  ...welcome
}
// 平台应用-获取应用开关
export function configGetMenuSwitch(params) {
  return API.GET(`/${envApi}/firm/config/getMenuSwitch`, params);
}
// 平台应用-判断是否有电子合同服务包
export function packageCheckApi(params)  {
  return API.POSTJSON(`/${envApi}/package/check`,params)
}
